import { OutOfPageAdType } from '@/modules/adv'

import style from './style.module.css'

export function renderTemplate(type: OutOfPageAdType, footerHeight: string, adBlockId: string) {
    const wrapper = document.createElement('div')
    wrapper.className = style.wrapper
    wrapper.style.height = `calc(100% - ${footerHeight})`

    wrapper.insertAdjacentHTML(
        'beforeend',
        `
    <div class="${style.ad_container}">
        <div class="${style.top_bar}">
            <button disabled class="${style.close_button}"></button>
        </div>
        <div id="${adBlockId}"></div>
    </div>
    `,
    )

    document.body.appendChild(wrapper)

    let countdownInterval: number
    let remainingTime = type === 'rewarded' ? 5 : 1

    const closeButton = wrapper.querySelector(`.${style.close_button}`) as HTMLButtonElement

    function updateCountdown() {
        if (remainingTime > 0) {
            closeButton.textContent = `Close Ad in ${remainingTime}`
        } else {
            closeButton.textContent = 'Close Ad'
            closeButton.disabled = false
            closeButton.style.background = '#fff'
            closeButton.style.color = '#000'
        }
    }

    function stopCountdown() {
        window.clearInterval(countdownInterval)
    }

    function startCountdown(cb: (sec: number) => void) {
        updateCountdown()
        cb(remainingTime)
        countdownInterval = window.setInterval(() => {
            remainingTime--
            updateCountdown()
            cb(remainingTime)
            if (remainingTime <= 0) {
                stopCountdown()
            }
        }, 1000)
    }

    function setOnClose(callback: () => void) {
        closeButton.addEventListener('click', callback)
    }

    return {
        wrapper,
        startCountdown,
        stopCountdown,
        setOnClose,
    }
}
